import React, { Component } from 'react';
import { Modal, Icon, Button } from 'antd';
import CrfPeriod from './CrfPeriod';

class PreviewVisit extends Component {
    state = {
        visible: false,
    }

    show = () => {
        this.setState({ visible: true });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadRefData = typeName => {
        if (typeName === 'Type_Filter') {
            this.visitRef.loadData();
        } else {
            this.filterRef.loadData();
        }
    }

    render() {
        const { visible } = this.state;
        const { isFilterProcess } = this.props; // 是否存在筛选流程
        return (
            <Modal
                title="预览访视记录"
                visible={visible}
                onCancel={this.hide}
                width="1200px"
                maskClosable={false}
                footer={<Button onClick={this.hide}>关闭</Button>}
            >
                {
                    isFilterProcess == 1 ? 
                    <div>
                        <Icon type="info-circle" style={{color: '#5750c9', marginRight: 4}} />
                        注：本项目包含筛选流程，因此只有经过筛选的患者，才能进入访视记录，访视记录中的“筛选编号”、“患者编号”、“知情同意时间”、“筛选时间”、“随机（入组）时间”都默认沿用筛选记录中的对应数据：
                    </div>
                    :
                    <div>
                        <Icon type="info-circle" style={{color: '#5750c9', marginRight: 4}} />
                        注：本项目不包含筛选流程，可直接添加访视记录，“筛选编号”、“筛选时间”不可填写”；
                    </div>
                }
                {
                    isFilterProcess == 1 && <div>
                        <div style={{ marginTop: 20 }}>假设某患者参与了筛选，填写了筛选记录数据：</div>
                        <div className="type_Filter" style={{ margin: '10px 0 20px' }}>
                            { visible && <CrfPeriod typeName="Type_Filter" loadRefData={this.loadRefData} ref={el => this.filterRef = el} /> }
                        </div>
                    </div>
                }
                {
                    isFilterProcess == 1 && <div>那么其访视记录如下：</div>
                }
                <div className="type_Visit" style={{ margin: '10px 0' }}>
                    { visible && <CrfPeriod typeName="Type_Visit" loadRefData={this.loadRefData} ref={el => this.visitRef = el} /> }
                </div>
            </Modal>
        );
    }
}

export default PreviewVisit;


// WEBPACK FOOTER //
// ./src/components/executeMgr/visitPeriodPlan/components/PreviewVisit.js